//get my content
export const GET_MY_CONTENT_REQUEST = "GET_MY_CONTENT_REQUEST";
export const GET_MY_CONTENT_RECEIVE = "GET_MY_CONTENT_RECEIVE";
export const GET_MY_CONTENT_FAILURE = "GET_MY_CONTENT_FAILURE";
export const RESET_GET_MY_CONTENT = "RESET_GET_MY_CONTENT";

//get video details
export const GET_VIDEO_DETAILS_REQUEST = "GET_VIDEO_DETAILS_REQUEST";
export const GET_VIDEO_DETAILS_RECEIVE = "GET_VIDEO_DETAILS_RECEIVE";
export const GET_VIDEO_DETAILS_FAILURE = "GET_VIDEO_DETAILS_FAILURE";
export const RESET_GET_VIDEO_DETAILS = "RESET_GET_VIDEO_DETAILS";

//get picture details
export const GET_PICTURE_DETAILS_REQUEST = "GET_PICTURE_DETAILS_REQUEST";
export const GET_PICTURE_DETAILS_RECEIVE = "GET_PICTURE_DETAILS_RECEIVE";
export const GET_PICTURE_DETAILS_FAILURE = "GET_PICTURE_DETAILS_FAILURE";
export const RESET_GET_PICTURE_DETAILS = "RESET_GET_PICTURE_DETAILS";

//get gallery details
export const GET_GALLERY_DETAILS_REQUEST = "GET_GALLERY_DETAILS_REQUEST";
export const GET_GALLERY_DETAILS_RECEIVE = "GET_GALLERY_DETAILS_RECEIVE";
export const GET_GALLERY_DETAILS_FAILURE = "GET_GALLERY_DETAILS_FAILURE";
export const RESET_GET_GALLERY_DETAILS = "RESET_GET_GALLERY_DETAILS";

//purchase content
export const PURCHASE_CONTENT_REQUEST = "PURCHASE_CONTENT_REQUEST";
export const PURCHASE_CONTENT_RECEIVE = "PURCHASE_CONTENT_RECEIVE";
export const PURCHASE_CONTENT_FAILURE = "PURCHASE_CONTENT_FAILURE";
export const RESET_PURCHASE_CONTENT = "RESET_PURCHASE_CONTENT";

//subscribe content
export const SUBSCRIBE_TO_BROADCASTER_REQUEST = "SUBSCRIBE_TO_BROADCASTER_REQUEST";
export const SUBSCRIBE_TO_BROADCASTER_RECEIVE = "SUBSCRIBE_TO_BROADCASTER_RECEIVE";
export const SUBSCRIBE_TO_BROADCASTER_FAILURE = "SUBSCRIBE_TO_BROADCASTER_FAILURE";
export const RESET_SUBSCRIBE_TO_BROADCASTER = "RESET_SUBSCRIBE_TO_BROADCASTER";

//get my history or purchase content
export const GET_MY_HISTORY_OR_PURCHASE_CONTENT_REQUEST = "GET_MY_HISTORY_OR_PURCHASE_CONTENT_REQUEST";
export const GET_MY_HISTORY_OR_PURCHASE_CONTENT_RECEIVE = "GET_MY_HISTORY_OR_PURCHASE_CONTENT_RECEIVE";
export const GET_MY_HISTORY_OR_PURCHASE_CONTENT_FAILURE = "GET_MY_HISTORY_OR_PURCHASE_CONTENT_FAILURE";
export const RESET_GET_MY_HISTORY_OR_PURCHASE_CONTENT = "RESET_GET_MY_HISTORY_OR_PURCHASE_CONTENT";
